import { appBootstrap } from "owa-app-module/lib/appBootstrap";
import { determineModule } from "owa-workloads/lib/utils/determineModule";
import { moduleToConfigMap } from "owa-bootstrap-configs";
import type { SessionData } from "owa-service/lib/types/SessionData";
import type { BootStrategies, ModuleConfigMap } from "owa-shared-start-types";

// TODO VSO 82257: Explicitly call code to set up selected calendars in boot rather than relying on 'owa-calendar-module-selected-calendars-user-config' orchestrators
/* eslint-disable-next-line owa-custom-rules/forbid-empty-import-statements-from-modules -- (https://aka.ms/OWALintWiki)
 * Baseline. DO NOT COPY AND PASTE!, replace this line with a justification or fix the issue.
 *	> Empty import statements from non-relative modules are not allowed. Either import something specific or remove the import. */
import "owa-calendar-module-selected-calendars-user-config/lib/orchestrators";

export async function mailAppBootstrap(sessionPromise: Promise<SessionData | undefined>, strategies?: BootStrategies, _configRegistry?: ModuleConfigMap<any>, requiredApplicationSettings?: string[]): Promise<void> {
    const config = moduleToConfigMap[determineModule()];
    const options = typeof config.optionsSync == "function"
        ? config.optionsSync(sessionPromise, strategies, requiredApplicationSettings)
        : await config.options.importAndExecute(sessionPromise, strategies);
    return appBootstrap(options, moduleToConfigMap);
}
